import { StreamVideoClient } from "@stream-io/video-react-sdk";
import { StreamChat } from "stream-chat";
import api from "./api";

// Cache singletons across navigations so we don't re-auth on every page mount.
let cached = { videoClient: null, chatClient: null, userId: null };

async function fetchToken() {
  const { data } = await api.post("/live/token");
  return data;
}

/**
 * Connect (or return existing) Stream Video + Chat clients for the current user.
 * Uses HttpOnly-cookie auth on the app side. Stream tokens are short-lived; we use a
 * tokenProvider so the Video SDK refreshes automatically on expiry.
 */
export async function getStreamClients() {
  if (cached.videoClient && cached.chatClient) return cached;

  const tokenData = await fetchToken();
  const user = {
    id: tokenData.user_id,
    name: tokenData.user_name,
    image: tokenData.user_image || undefined,
    badge_frame: tokenData.frame || null,
    badge_label: tokenData.badge_label || null,
    badge_emoji: tokenData.badge_emoji || null,
  };

  const tokenProvider = async () => {
    const refreshed = await fetchToken();
    return refreshed.user_token;
  };

  const videoClient = new StreamVideoClient({
    apiKey: tokenData.api_key,
    user,
    token: tokenData.user_token,
    tokenProvider,
  });

  const chatClient = StreamChat.getInstance(tokenData.api_key);
  if (!chatClient.userID) {
    await chatClient.connectUser(user, tokenData.user_token);
  }

  cached = { videoClient, chatClient, userId: user.id };
  return cached;
}

export async function disconnectStreamClients() {
  try {
    if (cached.videoClient) await cached.videoClient.disconnectUser();
    if (cached.chatClient) await cached.chatClient.disconnectUser();
  } catch (e) {
    console.warn("Stream disconnect failed", e);
  }
  cached = { videoClient: null, chatClient: null, userId: null };
}
